export default __webpack_public_path__ + "static/media/Isometric_Square_light-blue.928d960d.svg";